import React, { FC, useContext } from 'react';
import styled from 'styled-components';
import Routes from 'Routes';
import {
  selectAllValidBoothIds,
} from 'models/cms/booths';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBackIosRounded';
import ArrowFowardIcon from '@material-ui/icons/ArrowForwardIosRounded';
import useURLSearchParams from 'hooks/useURLSearchParams';
import { TabsContext } from 'components/TabsContext';
import useFetchSurroundingBoothsEffect from 'hooks/booth/useFetchSurroundingBoothsEffect';

interface BoothNavigationArrowsProps {
  isPreview: boolean;
}

const NavigationArrowIcon = styled(IconButton)`
  top: 350px;
  z-index: 1000;
  position: fixed;
  background-color: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;

const LeftNavigationArrowIcon = styled(NavigationArrowIcon)`
  left: 20px;
`;

const RightNavigationArrowIcon = styled(NavigationArrowIcon)`
  right: 20px;
`;

const BoothNavigationArrows: FC<BoothNavigationArrowsProps> = ({ isPreview }) => {
  const { boothId } = useParams<{ boothId: string }>();
  const history = useHistory();
  const { setActiveTabKey } = useContext(TabsContext);
  const query = useURLSearchParams();
  const boothIds = useSelector(selectAllValidBoothIds, shallowEqual);
  const boothIndex = boothIds.findIndex((id) => `${id}` === `${boothId}`);
  const prevBoothId = boothIds[boothIndex - 1];
  const nextBoothId = boothIds[boothIndex + 1];

  useFetchSurroundingBoothsEffect(boothId);

  return (
    <>
      {prevBoothId && !isPreview
      && (
        <LeftNavigationArrowIcon
          disabled={!prevBoothId}
          onClick={() => {
            setActiveTabKey(0);
            history.push({
              pathname: Routes.booth(prevBoothId),
              search: `?${query.toString()}`,
            });
          }}
        >
          <ArrowBackIcon />
        </LeftNavigationArrowIcon>
      )}
      {nextBoothId && !isPreview
      && (
        <RightNavigationArrowIcon
          disabled={!nextBoothId}
          onClick={() => {
            setActiveTabKey(0);
            history.push({
              pathname: Routes.booth(nextBoothId),
              search: `?${query.toString()}`,
            });
          }}
        >
          <ArrowFowardIcon />
        </RightNavigationArrowIcon>
      )}
    </>
  );
};

export default BoothNavigationArrows;
